import React from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import emailjs from 'emailjs-com';

const ContactForm = () => {
    const initialValues = {
        name: '',
        email: '',
        subject: '',
        message: '',
    };

    const validationSchema = Yup.object({
        name: Yup.string().required('Name is required'),
        email: Yup.string().email('Invalid email address').required('Email is required'),
        subject: Yup.string().required('Subject is required'),
        message: Yup.string().required('Message is required'),
    });

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
        // Send email to YOU (admin)
        const sendToAdmin = emailjs.send(
            'service_lh81ksj',          // Your service ID
            'template_zynuzpg',        // Template for admin
            values,
            'jtlEriHTRdqgtB7zH'         // Your public key
        );

        // Send confirmation to USER
        const sendToUser = emailjs.send(
            'service_lh81ksj',
            'template_9poax89', // New template for confirmation
            values,
            'jtlEriHTRdqgtB7zH'
        );

        // Wait for both to finish
        await Promise.all([sendToAdmin, sendToUser]);

        alert('Message sent! A confirmation has been emailed to you.');
        resetForm();
    } catch (error) {
        console.error('Error sending message:', error);
        alert('An error occurred. Please try again.');
    }
    setSubmitting(false);
};
    // EmailJS configuration

    return (
        <div id="contact" className="flex flex-col md:flex-row items-center justify-center gap-8 mx-auto p-6 w-full md:w-[80%] mt-10 mb-10">
            {/* Bottom/Right side with form */}
            <div className="w-full md:w-[80%] bg-white rounded-lg shadow-lg p-4 md:p-6 animate-pulse-purple">
                <style>
                    {`
                        @keyframes pulseGlow {
                            0% { box-shadow: 0 0 5px 2px rgba(147, 51, 234, 0.3), 0 0 5px 2px rgba(59, 130, 246, 0.3); }
                            50% { box-shadow: 0 0 20px 10px rgba(147, 51, 234, 0.5), 0 0 20px 10px rgba(59, 130, 246, 0.5); }
                            100% { box-shadow: 0 0 5px 2px rgba(147, 51, 234, 0.3), 0 0 5px 2px rgba(59, 130, 246, 0.3); }
                        }
                        .animate-pulse-purple {
                            animation: pulseGlow 2s infinite;
                        </div>}
                    `}
                </style>
                <h2 className="text-2xl font-bold mb-6 text-center">Tell us more about your project</h2>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ isSubmitting }) => (
                        <Form className="space-y-4">
                            <div>
                                <Field
                                    type="text"
                                    name="name"
                                    placeholder="Your Name"
                                    className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                />
                                <ErrorMessage
                                    name="name"
                                    component="div"
                                    className="text-red-500 text-sm mt-1"
                                />
                            </div>

                            <div>
                                <Field
                                    type="email"
                                    name="email"
                                    placeholder="Your Email"
                                    className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                />
                                <ErrorMessage
                                    name="email"
                                    component="div"
                                    className="text-red-500 text-sm mt-1"
                                />
                            </div>

                            <div>
                                <Field
                                    type="text"
                                    name="subject"
                                    placeholder="Subject"
                                    className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                />
                                <ErrorMessage
                                    name="subject"
                                    component="div"
                                    className="text-red-500 text-sm mt-1"
                                />
                            </div>

                            <div>
                                <Field
                                    as="textarea"
                                    name="message"
                                    placeholder="Your Message"
                                    rows="10"
                                    className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                />
                                <ErrorMessage
                                    name="message"
                                    component="div"
                                    className="text-red-500 text-sm mt-1"
                                />
                            </div>

                            <div className="flex justify-center">
                                <button
                                    type="submit"
                                    disabled={isSubmitting}
                                    className="w-full md:w-[50%] bg-purple-800 text-white py-2 px-4 rounded-lg hover:bg-purple-600 transition-colors duration-300 disabled:bg-blue-300"
                                >
                                    {isSubmitting ? 'Sending...' : 'Send Message'}
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    );
};

export default ContactForm;